// extracted by mini-css-extract-plugin
export var callCard = "_kt-0";
export var callMessageButton = "_kt-1";
export var helpIcon = "_kt-3";
export var helpIconContainer = "_kt-4";
export var verticalDivider = "_kt-2";